import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);

import magneticButton from '../snippets/magnetic-button.js'
import { onWidthResize, offWidthResize } from '../utils/resize.js';

export default class PageHero {
  constructor(element) {
    this.element = element;
    this.title = this.element.querySelector('.page-hero__title');
    this.description = this.element.querySelector('.page-hero__description');
    this.overlay = this.element.querySelector('.page-hero__overlay');
    this.media = this.element.querySelector('.page-hero__media');
    this.hero__cta = this.element.querySelector('.page-hero__cta')

    this.target = this.hero__cta?.dataset.ctaTarget;
    this.init();
    this.events();
  }

  init = () => {
    this.initPin();
    this.initMediaAnimation();
    this.initTitleAnimation();
    this.initDescriptionAnimation();
    this.initCtaAnimation();

    if (this.hero__cta) {
      new magneticButton(this.hero__cta, { inner_wrap: '.inner-wrap', inner_anim: '.inner-anim' });
    }
  }

  initPin = () => {


    gsap.fromTo(
      this.overlay,
      { opacity: 0 },
      {
        opacity: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: 'bottom top',
          pin: true,
          scrub: true,
        },
      }
    );

  }

  initMediaAnimation = () => {
    if (!this.media) return;
    gsap.fromTo(
      this.media,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 1.2,
        delay: 0.5,
        ease: 'power2.out',
        scrollTrigger: { trigger: this.element },
      }
    );
  }

  initCtaAnimation = () => {
    if (!this.hero__cta) return;
    // Animate the inner disc so GSAP transform (scale) never fights the
    // CTA's own layout (absolute centering on desktop, flow on mobile).
    const disc = this.hero__cta.querySelector('.inner-wrap') || this.hero__cta;
    gsap.fromTo(
      disc,
      { opacity: 0, scale: 0.8 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.8,
        delay: 1.4,
        ease: 'power3.out',
        scrollTrigger: { trigger: this.element },
      }
    );
  }

  initTitleAnimation = () => {
    if (!this.title) return;
    this.titleSplit = new SplitText(this.title, { type: 'lines,words', linesClass: 'lineParent' });
    gsap.fromTo(
      this.titleSplit.words,
      { yPercent: 100 },
      {
        yPercent: 0,
        duration: 0.8,
        delay: 1,
        stagger: { each: 0.08, ease: 'power2.out', from: 'start' },
        ease: 'power3.out',
        scrollTrigger: { trigger: this.element },
        onComplete: () => {
          onWidthResize(this.onTitleResize);
        },
      }
    );
  }

  onTitleResize = () => {
    this.titleSplit?.revert();
    offWidthResize(this.onTitleResize);
  }

  initDescriptionAnimation = () => {
    if (!this.description) return;
    this.descriptionSplit = new SplitText(this.description, { type: 'lines,words', linesClass: 'lineParent' });
    gsap.fromTo(
      this.descriptionSplit.words,
      { yPercent: 100 },
      {
        yPercent: 0,
        duration: 0.6,
        delay: 1,
        stagger: { each: 0.06, ease: 'power2.out', from: 'start' },
        ease: 'power3.out',
        scrollTrigger: { trigger: this.element },
        onComplete: () => {
          onWidthResize(this.onDescriptionResize);
        },
      }
    );
  }

  onDescriptionResize = () => {
    this.descriptionSplit?.revert();
    offWidthResize(this.onDescriptionResize);
  }
  events = () => {
    if (this.hero__cta) {
      this.hero__cta.addEventListener('click', this.onClick);
    }
  }

  onClick = (event) => {
    const targetEl = document.querySelector(this.target);
    if (!targetEl) return;
    event.preventDefault();
    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(targetEl, { offset: -40, duration: 1.2 });
    } else {
      targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
}
